import React from "react";
import { useLocation, Link as RouterLink } from "react-router-dom";
import { Card, Space, Typography } from "antd";
import CustomButton from "src/components/common/CustomButton";

export default function NotFoundPage() {
  const location = useLocation();

  return (
    <div style={{ padding: 24 }}>
      <Card style={{ borderRadius: 12 }} bordered>
        <Typography.Title level={4} style={{ fontWeight: 900, marginBottom: 8 }}>
          페이지를 찾을 수 없어요
        </Typography.Title>

        <Typography.Text style={{ color: "#8c8c8c" }}>
          요청하신 경로가 존재하지 않습니다.
        </Typography.Text>

        <div style={{ marginTop: 12, marginBottom: 16 }}>
          <Typography.Text style={{ fontSize: 13, color: "#8c8c8c" }}>
            현재 경로: <b>{location.pathname}</b>
          </Typography.Text>
        </div>

        <Space>
          <CustomButton variant="contained" component={RouterLink} to="/">
            대시보드로
          </CustomButton>
          <CustomButton variant="outlined" onClick={() => window.history.back()}>
            뒤로가기
          </CustomButton>
        </Space>
      </Card>
    </div>
  );
}
